import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import "./Admin.css";
import 'boxicons/css/boxicons.min.css';
import { Col, Container, Row, } from 'react-bootstrap';
import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import useAuth from "../../hooks/useAuth";
import TopBar from "./TopBar";

const UserProfile = () => {
  const [user, setUser] = useState(null);  // To store fetched animal data
  const [loading, setLoading] = useState(true); // To show loading spinner while fetching
  const [error, setError] = useState(null);    // To handle errors
  const axiosPrivate = useAxiosPrivate();
  const REGISTER_URL = "api/get-user";
  const { auth } = useAuth();
  const navigate = useNavigate();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate('/login');
  }

  useEffect(() => {
    const fetchData = async () => {
      const headers = {
        'Content-Type': 'application/json',
      };


      try {
        const response = await axiosPrivate.get(REGISTER_URL, {
          headers,
          withCredentials: true, // Ensures cookies are sent with the request if needed
        });
        setUser(response.data); // Store the fetched data into the user state
        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data");
        setLoading(false);  // Set loading to false even if there is an error
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner component if you prefer
  }

  if (error) {
    return <div>{error}</div>; // Display error message if any
  }

  if (user) {
    return (
      <Container>
        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
        {/* <div className="dashhead">
                <Row>
                    <Col><h5 className="dashhe">Profile</h5></Col>
                    <Col>
                    <div className="dashdiv">
                    <strong><i className="bx bxs-user icon dashicon"></i></strong> {auth?.name} / 
                    
                    <Link onClick={signOut} className="dashsign"><strong> <i className="bx bx-log-out icon dashiconr"></i></strong>  Sign Out</Link> 
                    </div>
                    </Col>
                </Row>
            </div> */}
        <center>
          <div style={{ width: '50%' }} className="userdiv">
            <div className="newprofile">
              <div className="admimg"><img src="/images/admin.png" width="15%" className='adm-img' /></div>
              <center><h4 className="adminhead">{user.name}</h4>
                <Row>
                  <p className="admsubhead">
                    {/* <strong>Franchise:</strong> */}
                    {user.franchise_name} </p>
                  <Col>
                    <p><strong><i className="bx bxs-user icon admicon"></i></strong> {user.user_name}</p>
                  </Col>
                  <Col>
                    <p><strong><i className="bx bxs-envelope icon admicon"></i></strong> {user.email}</p>
                  </Col>

                </Row>
              </center>
              <Row>
                <Col>
                  <p className="userole"><strong>Role:</strong> {user.role}</p>
                </Col>
                <Col>
                  <div className="last-login-section">
                    <p className="last-login">
                      <strong>
                        <i className="bx bxs-time  icon tmicon"></i>
                      </strong>{' '}
                      {new Date(user.last_login).toLocaleString()}
                    </p>
                  </div>
                </Col>

              </Row>
            </div>


            {/* <h1>User Profile</h1>
        <p><strong>Name:</strong> {user.name}</p>
        <p><strong>Username:</strong> {user.user_name}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Franchise:</strong> {user.franchise_name}</p>
        <p><strong>Last Login:</strong> {new Date(user.last_login).toLocaleString()}</p> */}
          </div></center>


        <TopBar />
      </Container>
    );
  }

  return <div>No user data available.</div>;
};

export default UserProfile;
